export default {
  "ID": "ID",
  "acccidentInsurance": "Acccident Insurance",
  "addManpowerBTN": "Add Manpower",
  "addManpowerModal": "Assign worker to contract",
  "additionalInformation": "Additional Information (If Any)",
  "address": "Address",
  "all": "All",
  "announce": "Announce",
  "announcement": "Announcement",
  "announcementAttachment": "Announcement Attachment",
  "applicantBearer": "Applicant / Bearer",
  "applicantNo": "Applicant No.",
  "applicationForContractorAccessCard": "Application for Contractor access card",
  "applicationFormForSpecialCase": "Application Form for Special Case",
  "appoint": "Appoint",
  "approvalBySectionHead": "Approval by Section Head",
  "approvalHistory": "History",
  "approvalResult": "Approval Result",
  "approvalType": "Approval Type",
  "approve": "Approve",
  "approved": "Approved",
  "approvedSucceeded": "Approved/Passed",
  "approver": "Approver",
  "approverPosition": "Approver Position",
  "assignWorkerToContract": "Assign worker to contract",
  "assignedContract": "Assigned Contract",
  "attention": "Attention",
  "bachelorDegre": "Bachelor Degre",
  "basicInfo": "Basic Information",
  "basicTraining": "Basic Training",
  "basicTrainingCertificate": "Basic Training Evidence",
  "basicTrainingCertificateRemark": "[NEED_TRANSLATION]* กดเมื่อทำการอบรมเรียบร้อยแล้ว หรือไม่กดหากต้องการนัดวันอบรม",
  "bearerNo": "Bearer No.",
  "bigTruck": "Big Truck",
  "birthdate": "Birthdate",
  "browse": "Browse",
  "canAccessRestrictedArea": "Restricted Area",
  "cancel": "Cancel",
  "cancelChange": "Cancel Change",
  "cancelExtend": "Cancel Extend",
  "cancellationReason": "Cancellation Reason",
  "cancelReasonExtension": "Cancellation for Extending the Contractor Card",
  "cancelRenew": "Cancel Renew",
  "carTypeBigTruck": "Big Truck",
  "carTypeCrane": "Crane",
  "carTypeFireTruck": "Fire Truck",
  "carTypeManagementCar": "Management Car",
  "carTypeOilTruck": "Oil Truck",
  "carTypeOther": "Other",
  "carTypePickUp": "PickUp",
  "carTypeVan": "Van",
  "cardApproval": "Card Approval",
  "cardNo": "Card No.",
  "cardPrinting": "Card Printing",
  "certificateNumber": "Certificate Number",
  "certificateOfBasicFireAndEvcuation": "Certificate of Basic fire and evcuation",
  "certificateOfFirstName/LastNameChange": "Certificate of First Name/Last Name Change",
  "certificateOfFlagman": "Certificate of Flagman",
  "certifiedHealthCheck": "Certified Health Check",
  "changeCard": "Change Card",
  "changeSticker": "Change Sticker",
  "checkUpDate": "Check-up Date",
  "chooseWorkerForManpowerList": "Choose Worker for Manpower List",
  "citizenDuplicateBody": "This worker is working on other contract, would you like to proceed?",
  "citizenDuplicateHeader": "Worker on another contract",
  "citizenID": "Citizen ID",
  "citizenIDCopy": "Citizen ID",
  "citizenIDPassportNumber": "Citizen ID /\nPassport number",
  "city": "City",
  "completeTrainingStatus": "Training Completed",
  "confinedSpace": "Confined Space",
  "confinedSpaceAuthorizer": "Confined Space Authorizer",
  "confinedSpaceCertificateAttachment": "Confined space certificate attachment",
  "confinedSpaceSupervisor": "Confined Space Supervisor",
  "confinedSpaceWorker": "Confined Space Worker",
  "confirm": "Confirm",
  "confirmDeletion": "Confirm Deletion",
  "consentToDisclosePersonalData": "Consent to disclose personal data",
  "contactAddress": "Contact Address",
  "contactUs": "Contact Us",
  "contractCoOrdinatorName": "Contract Coordinator Name",
  "contractHasNoCustodian": "This contract has no Custodian or Contract Coordinator. You cannot add manpower list. Please contact to contract Coordinator.",
  "contractList": "Contract List",
  "contractName": "Contract Name",
  "contractNo": "Contract No.",
  "contractStatus": "Contract Status",
  "contractorCompany": "Contractor Company",
  "contractorName": "Contractor Name",
  "contractorSupervisor": "Contractor Supervisor",
  "crane": "Crane",
  "craneExpiredDateOfCertified": "Expired Date of Certified",
  "craneMedicalCertificateAttachment": "Pleae attach Health Checked Certificate of Crane operator attachment",
  "craneOperator": "Crane Operator",
  "craneRigger": "Rigger",
  "craneRole": "Work Positions",
  "craneSignalMan": "Signal Man",
  "craneSupervisor": "Crane Supervisor",
  "createWorker": "Add Worker",
  "criticalTitle": "Warning",
  "criticality": "Criticality",
  "custodianName": "Custodian Name",
  "custodianSection": "Custodian Section",
  "cvOrResumeOrCertificateFromContractorCompany": "CV or Resume or Certificate From Contractor Company",
  "dateOfBirth": "Date of Birth",
  "dateOfCertified": "Date of Certified",
  "dateOfCertifiedHealthCheck": "Date of certified health check",
  "dateOfTraining": "Date of Training",
  "dateTime": "Date/Time",
  "degree": "degree",
  "deletionMessage": "Do you want to delete \"{$PH}\" ?",
  "district": "District",
  "doctoralDegrees": "Doctoral Degrees",
  "document": "Document",
  "documentIssueDate": "Document Issue Date",
  "downloadTemplateBtn": "Download Template",
  "driverLicense": "Driver License",
  "driverLicenseAttachment": "DriverLicense Attachment",
  "driverType": "Driver Type",
  "dropFileHere": "Drop file here",
  "elearning": "E-learning",
  "email": "Email",
  "endDate": "End Date",
  "err0000Message": "Please try again later or contact system admin",
  "errorAgreeText": "OK",
  "errorMessageAtlest": "Please fill atlest {$PH}",
  "errorMessageAtmost": "Please fill atmost {$PH}",
  "errorMessageBetween": "Please fill between {$PH} - {$PH_1}",
  "errorMessageCharacter": "character",
  "errorMessageCharacters": "characters",
  "errorMessageDigit": "digit",
  "errorMessageDigits": "digits",
  "errorMessageEmail": "Invalid email address",
  "errorMessageEnglishChar": "English characters",
  "errorMessageEqualTo": "Please fill equal to {$PH}",
  "errorMessageMinLength": "Please fill atleast {$PH} characters",
  "errorMessageNum": "digit",
  "errorMessageOr": "or",
  "errorMessagePrefix": "Kindly identify",
  "errorMessageRequired": "Please fill in the required fields",
  "errorMessageSameTo": "Please fill same as {$PH}",
  "errorMessageSpecialChar": "special characters",
  "errorMessageThaiChar": "Thai characters",
  "errorTitle": "System Failure",
  "ever": "Yes",
  "exampleDocument": "Example Document",
  "expWithThaioil": "Have you ever worked with Thai Oil Group?",
  "expireDate": "Expired Date",
  "expiredDateOfCertified": "Expired Date of Certified",
  "expiredDateOfDriverLicense": "Expired Date of Driver License",
  "expiredDateOfHealthCheck": "Expired date of health check",
  "expiredDateOfWorkPermit": "Expired Date of Work Permit",
  "extendCard": "Extend Card",
  "extendSticker": "Extend Sticker",
  "extensionContractorCard": "Extension Contractor Card",
  "extensionReason": "Extension Reason",
  "failTraining": "Training Failed",
  "fireTruck": "Fire Truck",
  "fireWatch": "Fire Watch",
  "fireWatchManTrainingCertificateAttachment": "Fire Watch Man Training Certificate Attachment",
  "fitToWork": "Fit to work",
  "flagman": "Flagman",
  "forkLift": "Forklift",
  "forklift": "Forklift Driver",
  "forkliftDriver": "Forklift Driver",
  "forkliftDriverCertificateAttachment": "Forklift Driver Certificate Attachment",
  "forkliftDriverFormAttachment": "Forklift Driver Form Attachment",
  "formTOPAttachment": "Form TOP Attachment",
  "fullName": "Name-LastName",
  "fullNameEN": "Name-LastName (EN)",
  "fullNameTH": "Name-LastName (TH)",
  "gender": "Gender",
  "highPressureWaterJet": "High Pressure Water Jet",
  "highPressureWaterJetCertificateAttachment": "High Pressure Water Jet Certificate Attachment",
  "highPressureWaterJetTrainingRequestAttachment": "High Pressure Water Jet Training Certificate Attachment",
  "highSchool": "High School",
  "holeWatch": "Hole Watch",
  "idenNo": "TOP Group Contractor Safety Trainer certified No.",
  "inProcess": "In Process",
  "infoTitle": "Attention Please",
  "interview": "Interview",
  "items": "items",
  "issuedCard": "Issued Card",
  "lastNameEN": "Lastname (EN)",
  "lastNameTH": "Lastname (TH)",
  "lastname": "Lastname",
  "lastname_EN": "Lastname EN",
  "lastname_TH": "Lastname TH",
  "logout": "Logout",
  "managementCar": "Management Car",
  "manpowerList": "Manpower List",
  "masterDegrees": "Master Degrees",
  "medicalCenterName": "Hospital/Medical center name",
  "medicalCertificate": "Medical Certificate or Yearly Medical Examination and TOP I-COVID form",
  "medicalCertificateAttachment": "Medical Certificate attachment",
  "medicalLicenceNo": "Medical licence No.",
  "name": "Name",
  "nameEN": "Name (EN)",
  "nameOfInstructor": "Name of Instructor",
  "nameTH": "Name (TH)",
  "name_EN": "Name EN",
  "name_TH": "Name TH",
  "nationality": "Nationality",
  "newCard": "New Card",
  "newExpiryDate": "New Expiry Date",
  "newSticker": "New Sticker",
  "no": "No",
  "notEver": "No",
  "fail": "Not Pass",
  "failed": "Not Passed",
  "oilTruck": "Oil Truck",
  "ok": "OK",
  "onlyActiveContracts": "Only Active Contracts",
  "or": "or",
  "order": "Order",
  "other": "Other",
  "otherNationality": "Other Nationalities {$INTERPOLATION}",
  "succeed": "Pass",
  "passport": "Passport number",
  "passportAddress": "Passport Address",
  "passportCopy": "Passport",
  "paymentCertificateAttachment": "Payment Certificate Attachment",
  "pending": "Pending",
  "phoneNumber": "Phone Number",
  "photoRecomend": "Photo (JPG File)",
  "physicianName": "Physician",
  "pickUp": "Pick Up",
  "plant": "Plant",
  "position": "Position",
  "positionLevel": "Position Level",
  "postalCode": "Postal Code",
  "primarySchool": "Primary School",
  "print": "Print",
  "printSticker": "Print Sticker",
  "printed": "Printing Completed",
  "printedSticker": "Printing Completed",
  "privacyPolicy": "Privacy Notice for Suppliers and Business Partner",
  "process": "Process",
  "processStep": "Process",
  "province": "Province",
  "reason": "Reason",
  "reasonOf": " Reason {$INTERPOLATION} ",
  "reasonRejected": "Reject Reason",
  "reassign": "Reassign",
  "reassignHistory": "Reassign History",
  "refresh": "Re-train",
  "reject": "Reject",
  "rejectReasonRequired": "Please fill reason",
  "rejected": "Rejected",
  "rejectedApproval": "Approval Rejected",
  "rejectedDocument": "Document Rejected",
  "rejectedInterview": "Interview Rejected",
  "rejectedFailed": "Rejected/Not Passed",
  "remarks": "Remarks",
  "renew": "Renew",
  "requestChange": "Request Change",
  "requestChangeEndDate": "Request change end date",
  "requestExtend": "Request Extend",
  "requestExtension": "Request Extension",
  "requestExtensionExpiryOfContractorCard": "Request for Extending the Expiry of Contractor Card",
  "requestForRefreshTrainingForCurrentYear": "Request for Refresh Training for Current Year",
  "requestedForTrainTheTrainerCourse": "Requested for train the trainer course",
  "resultApproval": "Result",
  "safety": "Safety",
  "safetyAuthorizer": "Course",
  "safetyCertificateAttachment": "Safety certificate attachment",
  "safetyofficerAtManagementCourse": "Safety officer at Management level",
  "safetyofficerAtProfessionalCourse": "Safety officer at professional level",
  "safetyofficerAtSupervisorCourse": "Safety officer at supervisor level",
  "safetyofficerAtTheAdvanceTechnicalCourse": "Safety officer at advance technical level",
  "safetyofficerAtTheTechnicalCourse": "Safety officer at the technical level",
  "save": "Save",
  "secondarySchool": "Secondary School",
  "section": "Section",
  "selectSpecialWorkType": "Select Special Work Type",
  "selfTrainingStatus": "Self Training",
  "sendApproval": "Send Approval",
  "sendApprovalItems": "Send Approval",
  "serviceGroup": "Service Group",
  "socialSecurity": "Social Security",
  "specialWorkInfo": "Special Work",
  "specialWorkType": "Special Work Type",
  "specifyExp": "If yes, please specify number of experienced year.",
  "startDate": "Start Date",
  "status": "Status",
  "statusExamDriverLicense": "Exam Status",
  "statusExamFireWatch": "Exam Status",
  "stickerApproval": "Sticker Approval : {$INTERPOLATION}",
  "subContractor": "Sub-Contractor",
  "summaryRequestCard": "Summary",
  "telNumber": "Tel Number",
  "titleEN": "Title (EN)",
  "titleTH": "Title (TH)",
  "toDateOfTraining": "to",
  "topGroupDriverLicense": "TOP Group Driver License",
  "totalContractorCard": "Total Contractor Card",
  "trainTheTrainerApplicationFormAttachment": "Train the trainer application form",
  "training": "Training",
  "trainingDate": "Training Date",
  "trainingDateFrom": "Date of training",
  "trainingDateTo": "to",
  "trainingInstitute": "Training Institute",
  "trainingStatus": "Training",
  "transcriptOfEducationAttachment": "Transcript of education attached file",
  "unFitToWork": "Unfit to work",
  "university": "University / college",
  "userGuideForAdmin": "User Guide for Admin",
  "userGuideForContractor": "User Guide",
  "userGuideForTOP": "User Guide",
  "validateCertificateContractor": "Please fill certificate contractor attachment",
  "validateForkliftDriverCertificateFiles": "Please fill Forklift Driver Certificate Attachment",
  "validateForkliftDriverFormFiles": "Please fill Forklift Driver Form Attachment",
  "validatePosition": "Please fill Work Positions",
  "validateSafetyAuthorizer": "Please identify at least 1 check",
  "validateTrainingFiles": "Please fill Confined space certificate attachment",
  "validateWorkHistoryFiles": "Please attach Resume/CV or Work history attachment",
  "van": "Van",
  "verificationProcess": "Verification process",
  "vocationalCertificate": "Vocational Certificate",
  "vocationalDiploma": "Vocational Diploma",
  "waitingForAE": "Waiting for AE",
  "waitingForAGSI": "Waiting for AGSI",
  "waitingForAnnouncement": "Waiting for Announcement",
  "waitingForAppoint": "Waiting for Appoint",
  "waitingForApproval": "Waiting for Approval",
  "waitingForApprovalBySectionHead": "Waiting for Approval by Section Head",
  "waitingForApprovalRequest": "Waiting for approval request",
  "waitingForBuyer": "Waiting for Buyer",
  "waitingForCustodian": "Waiting for Custodian",
  "waitingForDocument": "Waiting for Document Approval",
  "waitingForInterview": "Waiting for Interview",
  "waitingForIssuingCard": "Waiting for issuing card",
  "waitingForPerson": "Waiting for PM/SH",
  "waitingForPrint": "Waiting for Print",
  "waitingForPrintSticker": "Waiting for Print Sticker",
  "waitingForSafety": "Waiting for Safety",
  "waitingForSectionHead": "Waiting for Section Head",
  "waitingForSecurity": "Waiting for Security",
  "waitingForTraining": "Waiting for Training",
  "waitingForTrainingProcess": "Waiting for training process",
  "waitingForTrainingStatus": "Waiting for Training",
  "waitingForexamStatus": "Waiting",
  "warningTitle": "Please Check",
  "whenDidYouSucceedFlagmanTraining": "When do you passed Flagman training",
  "whenDidYouSucceedHighPressureWaterJetTraining": "When do you passed High Pressure Water Jet training",
  "whenSucceededFireWatchTraining": "When do you passed Fire Watch training ?",
  "workAtHeight(21M.)": "Work at Height (21 M.)",
  "workAtHeightCertificateAttachment": "Work at Height Certificate Attachment",
  "workAtHeightCitizenCardAttachment": "Worker Card, Identification Card",
  "workHistoryFiles": "Resume/CV or Work History ",
  "workInConfinedSpace": "Confined Space",
  "workInCrane": "Work in Crane",
  "workInCraneCertificateAttachment": "Crane Certificate Attachment",
  "workInSafety": "Safety",
  "workPermit": "Work Permit",
  "workPositions": "Work Positions",
  "workRisk": "Work Risk",
  "workType": "Work Type",
  "workerInfo": "Basic Work",
  "workerList": "Manpower List",
  "workerNo": "Worker No.",
  "yearForGraduated": "Year for graduated",
  "yes": "Yes"
}